import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { showToast } from '@/services/toast-service';
import { createBroadcastMessage } from '@/services/coloc-api/admin';

type BroadcastMessageErrorResponse = {
  errors?: Record<string, string[]>;
};

export const useCreateBroadcastMessage = () => {
  const mutation = useMutation({
    mutationKey: ['createBroadcastMessage'],
    mutationFn: createBroadcastMessage,
    onError: (error: AxiosError<BroadcastMessageErrorResponse>) => {
      if (error.response?.status === 422) {
        const { errors } = error.response.data ?? {};
        const text = errors
          ? Object.keys(errors).map((key) => errors[key].join(', ')).join('. ')
          : 'Please try again.';
        showToast.error({
          title: 'Failed to create broadcast message',
          text,
        });
        return;
      }

      showToast.error({
        title: 'Failed to create broadcast message',
        text: 'Please try again.',
      });
    },
  });

  return {
    createMessage: mutation.mutate,
    isLoading: mutation.isLoading,
    error: mutation.error,
  };
};
